<div class="">
  <div class="d-flex align-items-center gap-3 mb-3">
    <h6 class="mb-0" i18n>Automatic Security Deposit</h6>
    <div class="flex-fill"></div>
    <button [disabled]="processing" type="button" class="btn btn-secondary-info create-btn" (click)="save()">
      <i *ngIf="!processing" class="cs-icon cs-icon-save"></i>
      <i *ngIf="processing" class="far fa-spinner fa-spin"></i>
      <ng-container i18n>Save</ng-container>
    </button>
  </div>
  <div class="alert alert-secondary-info">
    <i class="fal fa-info-circle alert-icon"></i>
    <div class="alert-content" i18n>
      Configure an automatic security deposit for this rental. The deposit will be calculated and applied to bookings
      based on the settings below.
    </div>
  </div>
  <ng-container *ngIf="!isLoading; else loading">
    <app-security-deposit-form [form]="depositForm" [currencyCode]="currencyCode"></app-security-deposit-form>
  </ng-container>

  <ng-template #loading>
    <app-loading-section></app-loading-section>
  </ng-template>
</div>
